export const isStagingEnvironment = () => {
  return __IS_STAGING__ ? String(__IS_STAGING__).toLowerCase() === 'true' : false
}
